import * as z from "zod/v4";

export const toggleMobileMessageAi = {
  name: "toggleMobileMessageAi" as const,
  input: z.object({ conversationId: z.string(), aiDisabled: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
